
import { styled } from '@mui/material/styles';
import { Box, Typography, Button, Paper, TableCell, TableHead, TableRow, Chip } from '@mui/material';

export const MainContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
  padding: theme.spacing(3),
  width: '100%',
}));

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
}));

export const PageTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.25rem',
  color: '#333',
}));

export const UploadArea = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  textAlign: 'center',
  border: '2px dashed #5E8E7E',
  borderRadius: '12px',
  backgroundColor: '#f9fbfaf7',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: '#f1f7f5',
    borderColor: '#4A7A6A',
  },
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const UploadButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: '6px',
  backgroundColor: '#5E8E7E',
  color: '#fff',
  fontWeight: 600,
  padding: '10px 32px',
  '&:hover': {
    backgroundColor: '#4A7A6A',
  },
  '&:disabled': {
    backgroundColor: '#ccc',
  }
}));

export const SummaryCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: '8px',
  border: '1px solid #E0E0E0',
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
}));

export const SummaryItem = styled(Box)(({ theme }) => ({
  textAlign: 'center',
}));

export const SummaryValue = styled(Typography)<{ color?: string }>(({ color }) => ({
  fontSize: '1.5rem',
  fontWeight: 700,
  color: color || '#333',
}));

export const SummaryLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: '#666',
  fontWeight: 500,
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  '& th': {
    backgroundColor: '#5E8E7E',
    color: '#fff',
    fontWeight: 600,
    fontSize: '0.875rem',
  }
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#FAFAFA',
  },
  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: '0.875rem',
  padding: '12px 16px',
  color: '#333',
}));

export const StatusChip = styled(Chip)<{ status: 'success' | 'warning' | 'failed' | 'validated' }>(({ status }) => ({
  fontWeight: 600,
  borderRadius: '4px',
  fontSize: '0.75rem',
  height: '24px',
  ...(status === 'success' && {
    backgroundColor: '#E8F5E9',
    color: '#2E7D32',
  }),
  ...(status === 'validated' && {
    backgroundColor: '#E3F2FD',
    color: '#1976D2',
  }),
  ...(status === 'warning' && {
    backgroundColor: '#FFFDE7',
    color: '#F9A825',
  }),
  ...(status === 'failed' && {
    backgroundColor: '#FFEBEE',
    color: '#C62828',
  }),
}));
